// extracted by mini-css-extract-plugin
module.exports = {"uppercase-label":"uppercase-label__uppercase-label___2Xked"};